export const SELECT_OPTION = 'selectOption';
export default {};
